export const dynamicPricesAvailabilityMock = {
  startDate: '2024-03-22T22:00:00.000',
  endDate: '2024-03-25T22:00:00.000',
  isNextAvailable: true,
  isPrevAvailable: true,
  isNextLoading: false,
  isPrevLoading: false,
};
